/**
 * Mock comments service.
 * Mirrors the real comments.service.js API with in-memory data.
 */
import { MOCK_COMMENTS_BY_POST } from '../../data/mock/mock-comments.data';
import { mockDelay, mockLog, mockId } from './mock-delay';

// In-memory state - deep clone the comments map
let commentsByPost = {};
Object.entries(MOCK_COMMENTS_BY_POST).forEach(([postId, comments]) => {
  commentsByPost[postId] = [...comments];
});

export const addComment = async (postId, { text, author }) => {
  mockLog('CommentsService', 'addComment', { postId, text: text.substring(0, 30) });
  await mockDelay();
  const comment = {
    id: `mock_cmt_${mockId()}`,
    text: text.trim(),
    authorId: author.uid,
    authorName: author.displayName,
    authorUsername: author.username,
    authorAvatarUrl: author.avatarUrl || null,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    _docSnapshot: null,
  };
  if (!commentsByPost[postId]) commentsByPost[postId] = [];
  commentsByPost[postId].push(comment);
  return comment;
};

export const getComments = async (postId, lastDoc = null, pageLimit = 10) => {
  mockLog('CommentsService', 'getComments', { postId, lastDoc, pageLimit });
  await mockDelay();
  const allComments = (commentsByPost[postId] || []).sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );
  let startIndex = 0;
  if (lastDoc) {
    const idx = allComments.findIndex((c) => c.id === lastDoc);
    if (idx !== -1) startIndex = idx + 1;
  }
  const page = allComments.slice(startIndex, startIndex + pageLimit);
  const newLastDoc = page.length > 0 ? page[page.length - 1].id : null;
  const hasMore = startIndex + pageLimit < allComments.length;
  return { comments: page, lastDoc: newLastDoc, hasMore };
};

export const updateComment = async (postId, commentId, text) => {
  mockLog('CommentsService', 'updateComment', { postId, commentId });
  await mockDelay();
  const comments = commentsByPost[postId] || [];
  const idx = comments.findIndex((c) => c.id === commentId);
  if (idx !== -1) {
    comments[idx] = { ...comments[idx], text: text.trim(), updatedAt: new Date().toISOString() };
    return comments[idx];
  }
  return null;
};

export const deleteComment = async (postId, commentId) => {
  mockLog('CommentsService', 'deleteComment', { postId, commentId });
  await mockDelay();
  if (commentsByPost[postId]) {
    commentsByPost[postId] = commentsByPost[postId].filter((c) => c.id !== commentId);
  }
  return commentId;
};
